<template>
  <div class="relative">
    <img
      :src="imageUrl"
      class="antialiased bg-black bg-cover rounded-full athlete-avatar"
      :class="[isLoggedOut ? 'block md:mx-auto' : '']"
      v-if="hasImage && !imageError"
      :style="imageStyles"
      :alt="`${firstName} ${lastName}`"
      @error="handleImageError"
    />
    <DefaultAvatar
      :firstName="firstName"
      :lastName="lastName"
      :size="size"
      :isLoggedOut="isLoggedOut"
      :bgColor="bgColor"
      v-else
    />
  </div>
</template>

<script>
import DefaultAvatar from "@/components/DefaultAvatar";

export default {
  components: {
    DefaultAvatar,
  },
  props: {
    firstName: { type: String, required: false, default: "" },
    lastName: { type: String, required: false, default: "" },
    size: { type: String | Number, default: 16 },
    imageUrl: { type: String, required: false, default: null },
    isLoggedOut: { type: Boolean, default: true },
    bgColor: { type: String, required: false, default: "" },
    verifiedTooltipPosition: { type: String, required: false, default: "top" },
  },
  data() {
    return {
      imageError: false
    };
  },
  computed: {
    imageStyles: function () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`
      };
    },
    hasImage() {
      return !!this.imageUrl;
    },
  },

  methods: {
    handleImageError() {
      this.imageError = true;
    },
  },
};
</script>

<style scoped>
</style>
